import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

// Helper to get last 12 months
const getLast12Months = () => {
  const months = [];
  const today = new Date();

  for (let i = 11; i >= 0; i--) {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    months.push({
      label: d.toLocaleString("default", { month: "short", year: "numeric" }),
      month: d.getMonth() + 1,
      year: d.getFullYear(),
    });
  }
  return months;
};

const MonthlyUserRegistration = ({ apiData = [] }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const months = getLast12Months();

    const counts = months.map((m) => {
      const found = apiData.find(
        (d) => Number(d.month) === Number(m.month) && Number(d.year) === Number(m.year)
      );
      return found ? (Number(found.total) || 0) : 0;
    });

    setChartData({
      labels: months.map((m) => m.label),
      datasets: [
        {
          label: "Monthly Registrations",
          data: counts,
          backgroundColor: "#8e44ad",
          borderRadius: 6,
          barThickness: 28,
        },
      ],
    });
  }, [apiData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <div className="col-xl-6">
      <div className="card pending-app mt-2 mb-4">
        <div className="card-body p-3">
          <h4>
            <i className="far fa-users" style={{ marginRight: 8, color: "#8e44ad" }} />
            Monthly User Growth / Registrations
          </h4>

          <div style={{ height: 300 }}>
            {chartData.labels && <Bar data={chartData} options={options} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyUserRegistration;
